import Button from "components/atoms/Button";
import ReduxFormFields from "components/molecules/ReduxFormFields";
import { reduxForm } from "redux-form";
import { fields } from ".";
import { useEffect } from "react";
import DynamicService from "services/dynamics.service";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { Box, Paper, Typography, IconButton } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import LoopIcon from "@mui/icons-material/Loop";
import SubscriptionService from "services/subscription.service";
import BlockComponent from "components/organisms/BlockComponent/BlockComponent";
import { MODAL, modalActions } from "redux/slices/modal";

function KioskHomeVideoForm({ handleSubmit }: any) {
  const dispatch = useAppDispatch();
  const video = useAppSelector((state) => state.dynamics.videoMedia);

  useEffect(() => {
    DynamicService.getKioskMedia();
  }, []);

  return (
    <>
      {video?.media && (
        <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Current video preview
          </Typography>
          <Box sx={{
            position: "relative",
            width: "100%",
            maxWidth: 480,
            borderRadius: 1,
            overflow: "hidden",
            border: "1px solid #e0e0e0",
            backgroundColor: "#000",
          }}>
            <video
              src={video?.media}
              controls
              autoPlay
              muted
              loop
              style={{ display: "block", width: "100%", height: "400px" }}
            />
            <Box sx={{ position: "absolute", bottom: 8, left: 8, display: "flex", gap: 1, color: "#fff" }}>
              <PlayArrowIcon fontSize="small" />
              <VolumeOffIcon fontSize="small" />
              <LoopIcon fontSize="small" />
            </Box>
          </Box>
          {video?.media &&
            <Box sx={{ mt: 1 }}>
              <BlockComponent permission="dynamics:delete">
              <Button
                // color="secondary"
                variant="contained"
                onClick={() => {
                  SubscriptionService.subscribe(() => {
                    DynamicService.deleteKioskHomeVideo();
                  });
                  dispatch(
                    modalActions.openModal({
                      width: "500px",
                      type: MODAL.CONFIRMATION_FORM,
                      data: {
                        heading: "Remove Kiosk Home Video",
                        message: "Are you sure you want to remove the current video?",
                      },
                    })
                  );
                }}
              >
                Remove
              </Button>
              </BlockComponent>
            </Box>
          }
        </Paper>
      )}
      <form onSubmit={handleSubmit}>
        <ReduxFormFields fields={fields} />
        <br />
        <Button type="submit" variant="contained">Upload</Button>
      </form>
    </>
  );
}

export default reduxForm({ form: "KioskHomeVideoForm" })(KioskHomeVideoForm);


